export interface Movie {
  id: string;
  title: string;
  type: 'movie' | 'tv';
  year: number;
  region: string;
  genres: string[];
  director: string;
  cast: string[];
  synopsis: string;
  rating: number;
  views: number;
  poster: string;
  backdrop: string;
}

export const movies: Movie[] = [
  {
    id: 'night-desire',
    title: '暗夜迷情',
    type: 'movie',
    year: 2026,
    region: '美国',
    genres: ['惊悚', '悬疑'],
    director: '卢卡斯·格兰特',
    cast: ['伊莎贝尔·罗琳', '马库斯·雷德', '克莱尔·范恩'],
    synopsis:
      '一名专栏作家在深夜收到匿名信件，被卷入一场关于欲望与谎言的迷局。她必须在真相与自保之间做出选择，而每一封信都指向她不愿面对的过去。',
    rating: 8.4,
    views: 186320,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20mysterious%20woman%20silhouette%20at%20a%20rainy%20window%20at%20night%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20elegant%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=sexmv-p01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20lonely%20city%20street%20at%20midnight%20with%20glowing%20red%20neon%20reflections%20on%20wet%20asphalt%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%20shadows%2C%20no%20text&width=1600&height=900&seq=sexbd-01&orientation=landscape',
  },
  {
    id: 'red-lips',
    title: '红唇密语',
    type: 'movie',
    year: 2025,
    region: '法国',
    genres: ['爱情', '剧情'],
    director: '艾洛蒂·莫罗',
    cast: ['莉亚·杜邦', '安托万·贝尔', '苏菲·朗'],
    synopsis:
      '在巴黎左岸的一间老咖啡馆里，两个陌生人因为一本借错的日记而产生了交集。他们交换秘密，也交换了各自无法挣脱的孤独，情感的边界在谈判桌上一点点模糊。',
    rating: 7.9,
    views: 142870,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20woman%20with%20deep%20red%20lipstick%20in%20soft%20shadow%2C%20parisian%20cafe%20background%20blurred%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p02&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20an%20intimate%20parisian%20cafe%20interior%20at%20dusk%20with%20warm%20red%20lamplight%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%20shadows%2C%20no%20text&width=1600&height=900&seq=sexbd-02&orientation=landscape',
  },
  {
    id: 'forbidden-edge',
    title: '禁忌边界',
    type: 'movie',
    year: 2026,
    region: '韩国',
    genres: ['剧情', '悬疑'],
    director: '郑河俊',
    cast: ['韩素妍', '李正宇', '朴敏书'],
    synopsis:
      '一桩看似普通的失踪案，牵扯出一个家庭多年来精心维系的体面。当调查逼近真相，所有被压抑的欲望与恐惧同时浮出水面，边界一旦越过便无法回头。',
    rating: 8.1,
    views: 165540,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20reflective%20glass%20corridor%20with%20a%20single%20distant%20figure%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=sexmv-p03&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20modern%20seoul%20apartment%20at%20night%20with%20red%20city%20lights%20outside%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%20shadows%2C%20no%20text&width=1600&height=900&seq=sexbd-03&orientation=landscape',
  },
  {
    id: 'neon-abyss',
    title: '霓虹深渊',
    type: 'movie',
    year: 2025,
    region: '中国香港',
    genres: ['犯罪', '动作'],
    director: '麦兆辉',
    cast: ['陈俊尧', '林嘉欣', '何镇东'],
    synopsis:
      '一名卧底警员在黑帮核心潜伏多年，身份与情感同时被撕扯。霓虹灯下没有真正的赢家，只有谁先撑不住。他要在一夜之间决定，自己究竟属于哪一边。',
    rating: 8.0,
    views: 158910,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20lone%20figure%20in%20a%20rain-soaked%20neon%20alley%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=sexmv-p04&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20hong%20kong%20neon%20street%20at%20night%20reflected%20in%20rain%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%20shadows%2C%20no%20text&width=1600&height=900&seq=sexbd-04&orientation=landscape',
  },
  {
    id: 'caged-butterfly',
    title: '笼中蝶',
    type: 'tv',
    year: 2026,
    region: '日本',
    genres: ['剧情', '爱情'],
    director: '高桥早纪',
    cast: ['佐藤遥', '山崎凉太', '中村美咲'],
    synopsis:
      '一位被家族安排人生的千金，与一名自由摄影师相遇。她想挣脱金笼，他却不属于任何地方。两个人在四季更替里试探彼此，也试探自己真正想要的自由。',
    rating: 8.2,
    views: 173450,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20butterfly%20against%20a%20dark%20ornate%20window%20frame%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20elegant%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=sexmv-p05&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20traditional%20japanese%20room%20at%20dusk%20with%20red%20paper%20lanterns%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%20shadows%2C%20no%20text&width=1600&height=900&seq=sexbd-05&orientation=landscape',
  },
  {
    id: 'midnight-letter',
    title: '午夜信笺',
    type: 'movie',
    year: 2024,
    region: '英国',
    genres: ['剧情', '文艺'],
    director: '艾米莉亚·怀特',
    cast: ['奥利弗·班克斯', '格蕾丝·霍尔', '诺亚·里德'],
    synopsis:
      '一位退休的钢琴家在整理旧宅时发现了四十年前未寄出的信。他决定一封封读完，在旋律与回忆之间，重新面对那段被他亲手放弃的感情。',
    rating: 7.6,
    views: 98420,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20stack%20of%20old%20letters%20beside%20a%20candle%20on%20a%20wooden%20desk%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p06&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20dim%20english%20library%20with%20a%20grand%20piano%20and%20red%20curtains%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%20shadows%2C%20no%20text&width=1600&height=900&seq=sexbd-06&orientation=landscape',
  },
  {
    id: 'crime-and-longing',
    title: '罪与欲',
    type: 'movie',
    year: 2025,
    region: '美国',
    genres: ['犯罪', '剧情'],
    director: '丹尼尔·克罗斯',
    cast: ['杰克·蒙罗', '维拉·索恩', '雷蒙·福斯特'],
    synopsis:
      '一位声名显赫的辩护律师接下了自己无法拒绝的案子，被告却勾起了他尘封的欲望。当职业操守与私人冲动相撞，他第一次发现法律也保护不了自己。',
    rating: 8.3,
    views: 177610,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20courtroom%20gavel%20and%20a%20woman%20silhouette%20in%20shadow%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p07&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20an%20empty%20courtroom%20at%20night%20lit%20by%20a%20single%20red%20lamp%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%20shadows%2C%20no%20text&width=1600&height=900&seq=sexbd-07&orientation=landscape',
  },
  {
    id: 'blood-rose',
    title: '血色玫瑰',
    type: 'movie',
    year: 2026,
    region: '西班牙',
    genres: ['惊悚', '爱情'],
    director: '卡洛斯·门德斯',
    cast: ['伊莎贝尔·纳瓦罗', '迭戈·奥尔莫', '露西亚·维加'],
    synopsis:
      '一支来自异国的舞团巡演至一座古老庄园，领舞者却在首演前失踪。随着排练继续，团员之间的爱恨逐渐失控，最鲜艳的那朵玫瑰，往往带着刺。',
    rating: 7.8,
    views: 131280,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20single%20blood%20red%20rose%20on%20a%20dark%20velvet%20cloth%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p08&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20spanish%20mansion%20ballroom%20candlelit%20at%20night%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%20shadows%2C%20no%20text&width=1600&height=900&seq=sexbd-08&orientation=landscape',
  },
  {
    id: 'desire-district',
    title: '欲望街区',
    type: 'tv',
    year: 2025,
    region: '美国',
    genres: ['剧情', '都市'],
    director: '娜塔莉·科尔',
    cast: ['瑞秋·布莱克', '戴米安·罗斯', '洛拉·詹姆斯'],
    synopsis:
      '在一座不夜城的公寓楼里，六位邻居的生活因一桩交易被紧紧缠绕。每个人都在追逐自己想要的东西，也都在隐瞒自己付出的代价。',
    rating: 8.0,
    views: 168220,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20high%20rise%20apartment%20facade%20at%20night%20with%20red%20window%20lights%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p09&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20glamorous%20city%20rooftop%20penthouse%20at%20night%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%20shadows%2C%20no%20text&width=1600&height=900&seq=sexbd-09&orientation=landscape',
  },
  {
    id: 'screen-dark',
    title: '银幕之暗',
    type: 'movie',
    year: 2024,
    region: '法国',
    genres: ['文艺', '剧情'],
    director: '皮埃尔·洛朗',
    cast: ['克莱芒·吉拉尔', '艾娃·卢梭', '马修·布兰'],
    synopsis:
      '一间即将停业的老电影院，最后一位放映员决定为一位常客重映一部旧片。放映机的光里，藏着两个孤独灵魂说不出口的默契。',
    rating: 7.5,
    views: 87260,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20vintage%20film%20projector%20beam%20in%20a%20dark%20theater%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p10&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20an%20old%20empty%20movie%20theater%20with%20red%20seats%20and%20glowing%20screen%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20no%20text&width=1600&height=900&seq=sexbd-10&orientation=landscape',
  },
  {
    id: 'stranger-pillow',
    title: '枕边陌客',
    type: 'movie',
    year: 2026,
    region: '韩国',
    genres: ['惊悚', '爱情'],
    director: '郑河俊',
    cast: ['韩素妍', '姜泰民', '尹書雅'],
    synopsis:
      '她每天醒来都发现身边的人有些不同。是记忆出了问题，还是有人在精心编织她的生活？当信任被一寸寸瓦解，逃离也成了一种冒险。',
    rating: 8.1,
    views: 160430,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20an%20unmade%20bed%20in%20a%20dim%20room%20with%20light%20through%20blinds%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p11&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20dim%20bedroom%20with%20red%20curtains%20and%20long%20shadows%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%2C%20no%20text&width=1600&height=900&seq=sexbd-11&orientation=landscape',
  },
  {
    id: 'burning-night',
    title: '燃烧的夜',
    type: 'movie',
    year: 2025,
    region: '日本',
    genres: ['爱情', '剧情'],
    director: '高桥早纪',
    cast: ['佐藤遥', '小林悠真', '藤井遥花'],
    synopsis:
      '一场夏夜的祭典上，两个即将各奔东西的年轻人约定，用一个夜晚记住彼此。烟花散尽之后，热的到底是夏天，还是他们谁都不肯承认的心意。',
    rating: 7.7,
    views: 118540,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20couple%20silhouette%20against%20festival%20fireworks%20at%20night%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p12&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20japanese%20summer%20festival%20street%20at%20night%20with%20red%20lanterns%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%2C%20no%20text&width=1600&height=900&seq=sexbd-12&orientation=landscape',
  },
  {
    id: 'silent-night',
    title: '沉默羔羊夜',
    type: 'tv',
    year: 2026,
    region: '美国',
    genres: ['悬疑', '犯罪'],
    director: '丹尼尔·克罗斯',
    cast: ['维拉·索恩', '艾略特·格兰特', '玛莎·金'],
    synopsis:
      '一名犯罪心理学顾问被请来协助追查连环案件，她发现凶手每一步都在模仿她多年前未公开的论文。真相与她的过去，被同一根线牵着。',
    rating: 8.5,
    views: 191050,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20lone%20street%20lamp%20in%20dense%20fog%20at%20night%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=sexmv-p13&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20foggy%20city%20bridge%20at%20night%20with%20a%20single%20figure%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%2C%20no%20text&width=1600&height=900&seq=sexbd-13&orientation=landscape',
  },
  {
    id: 'rose-and-gun',
    title: '玫瑰与枪',
    type: 'movie',
    year: 2025,
    region: '中国香港',
    genres: ['动作', '犯罪'],
    director: '麦兆辉',
    cast: ['林嘉欣', '陈俊尧', '黄志强'],
    synopsis:
      '一名退役杀手被旧日搭档找上门，要她完成最后一单。目标却与她的过去有关，而枪口另一端的犹豫，比子弹更致命。',
    rating: 7.9,
    views: 146780,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20woman%20holding%20a%20rose%20in%20one%20hand%20in%20shadow%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p14&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20dark%20warehouse%20with%20red%20emergency%20lighting%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%2C%20no%20text&width=1600&height=900&seq=sexbd-14&orientation=landscape',
  },
  {
    id: 'misty-manor',
    title: '迷雾庄园',
    type: 'tv',
    year: 2024,
    region: '英国',
    genres: ['悬疑', '历史'],
    director: '艾米莉亚·怀特',
    cast: ['格蕾丝·霍尔', '埃德加·芬奇', '萝丝·卡特'],
    synopsis:
      '十九世纪末，一位年轻女继承人回到家族庄园处理遗产，却发现宅邸里的每个人都守着同一段旧事。雾散之后，秘密比鬼魂更难面对。',
    rating: 8.0,
    views: 122340,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20gothic%20manor%20silhouette%20in%20dense%20fog%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p15&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20foggy%20victorian%20manor%20hallway%20with%20candlelight%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%2C%20no%20text&width=1600&height=900&seq=sexbd-15&orientation=landscape',
  },
  {
    id: 'barcelona-love',
    title: '情迷巴塞罗那',
    type: 'movie',
    year: 2026,
    region: '西班牙',
    genres: ['爱情', '剧情'],
    director: '卡洛斯·门德斯',
    cast: ['露西亚·维加', '迭戈·奥尔莫', '马特奥·里奥斯'],
    synopsis:
      '一位建筑师出差至巴塞罗那，与当地一名舞者共度了三天。回到原本生活后，他才发现自己早已把心留在了高迪的屋顶上。',
    rating: 7.8,
    views: 129640,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20couple%20dancing%20in%20a%20sunlit%20barcelona%20courtyard%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20warm%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p16&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20barcelona%20rooftop%20terrace%20at%20sunset%20with%20warm%20red%20tones%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%2C%20no%20text&width=1600&height=900&seq=sexbd-16&orientation=landscape',
  },
  {
    id: 'dark-undercurrent',
    title: '暗涌',
    type: 'tv',
    year: 2025,
    region: '韩国',
    genres: ['剧情', '悬疑'],
    director: '郑河俊',
    cast: ['李正宇', '朴敏书', '崔恩熙'],
    synopsis:
      '一家看似平静的财阀家族，在一场婚礼后被接连的意外搅乱。每个人都有一份不愿公开的协议，而平静的水面下，暗涌早已成形。',
    rating: 8.2,
    views: 171320,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20dark%20rippling%20water%20reflecting%20a%20city%20skyline%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p17&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20an%20elegant%20banquet%20hall%20at%20night%20with%20red%20chandeliers%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%2C%20no%20text&width=1600&height=900&seq=sexbd-17&orientation=landscape',
  },
  {
    id: 'last-dance',
    title: '最后一支舞',
    type: 'movie',
    year: 2024,
    region: '法国',
    genres: ['爱情', '文艺'],
    director: '艾洛蒂·莫罗',
    cast: ['莉亚·杜邦', '克莱芒·吉拉尔', '艾娃·卢梭'],
    synopsis:
      '一支即将解散的舞团决定用最后一场演出告别。两位曾是最佳搭档的舞者，必须在这支舞里，把当年没说出口的话一次跳完。',
    rating: 7.6,
    views: 94280,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20two%20dancers%20in%20a%20dramatic%20pose%20under%20a%20single%20spotlight%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p18&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20an%20empty%20theater%20stage%20with%20red%20velvet%20curtains%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%2C%20no%20text&width=1600&height=900&seq=sexbd-18&orientation=landscape',
  },
  {
    id: 'paradise-lost-street',
    title: '失乐园街',
    type: 'movie',
    year: 2026,
    region: '日本',
    genres: ['剧情', '悬疑'],
    director: '高桥早纪',
    cast: ['中村美咲', '山崎凉太', '小林悠真'],
    synopsis:
      '一条即将拆迁的老街，住户们各自握着一个秘密。一位年轻的记录者前来采访，却逐渐发现自己也成了这条街故事的一部分。',
    rating: 7.9,
    views: 137640,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20narrow%20japanese%20alley%20at%20dusk%20with%20warm%20shop%20lights%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p19&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20quiet%20japanese%20street%20at%20dusk%20with%20red%20lantern%20glow%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%2C%20no%20text&width=1600&height=900&seq=sexbd-19&orientation=landscape',
  },
  {
    id: 'edge-city',
    title: '边缘之城',
    type: 'tv',
    year: 2025,
    region: '美国',
    genres: ['犯罪', '惊悚'],
    director: '娜塔莉·科尔',
    cast: ['戴米安·罗斯', '瑞秋·布莱克', '雷蒙·福斯特'],
    synopsis:
      '在一座边境城市里，执法者与走私者遵守着同一套不成文的规矩。当规矩被打破，所有人都被迫重新选择站在哪一边。',
    rating: 8.1,
    views: 155890,
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20poster%20of%20a%20desert%20highway%20at%20night%20with%20red%20tail%20lights%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20dramatic%20low-key%20lighting%2C%20no%20text&width=600&height=900&seq=sexmv-p20&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%20of%20a%20gritty%20border%20town%20street%20at%20night%20with%20red%20signage%2C%20deep%20crimson%20and%20charcoal%20color%20grade%2C%20atmospheric%2C%20no%20text&width=1600&height=900&seq=sexbd-20&orientation=landscape',
  },
];

export const featuredIds: string[] = [
  'night-desire',
  'silent-night',
  'caged-butterfly',
  'crime-and-longing',
  'dark-undercurrent',
];